import React, { useState } from "react";

const NetworkInfra = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  // Sri Lanka locations with healthcare facilities
  const locations = [
    { id: 1, name: "Colombo", lat: 6.9271, lng: 80.7789, centers: 120, pharmacies: 45, labs: 40, type: "major" },
    { id: 2, name: "Kandy", lat: 7.2906, lng: 80.6337, centers: 85, pharmacies: 30, labs: 25, type: "major" },
    { id: 3, name: "Galle", lat: 6.0535, lng: 80.2170, centers: 65, pharmacies: 25, labs: 20, type: "secondary" },
    { id: 4, name: "Jaffna", lat: 9.6615, lng: 80.7855, centers: 60, pharmacies: 22, labs: 18, type: "secondary" },
    { id: 5, name: "Kurunegala", lat: 7.4863, lng: 80.3635, centers: 75, pharmacies: 28, labs: 22, type: "secondary" },
    { id: 6, name: "Matara", lat: 5.7431, lng: 80.5353, centers: 58, pharmacies: 20, labs: 16, type: "secondary" },
    { id: 7, name: "Ratnapura", lat: 6.6828, lng: 80.3892, centers: 52, pharmacies: 18, labs: 14, type: "tertiary" },
    { id: 8, name: "Anuradhapura", lat: 8.3163, lng: 80.4167, centers: 70, pharmacies: 26, labs: 21, type: "secondary" },
  ];

  // Map is now embedded via iframe, no need for dynamic script loading
  // Users can click on major hub locations in the info panel to view details

  return (
  <>
    <style>{`
      @keyframes slideInUp {
        from {
          opacity: 0;
          transform: translateY(30px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @keyframes scaleIn {
        from {
          opacity: 0;
          transform: scale(0.9);
        }
        to {
          opacity: 1;
          transform: scale(1);
        }
      }

      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.7; }
      }

      .network-header {
        animation: slideInUp 0.8s ease-out;
      }

      .network-stat {
        animation: scaleIn 0.6s ease-out;
      }

      .network-stat:nth-child(1) { animation-delay: 0.1s; }
      .network-stat:nth-child(2) { animation-delay: 0.2s; }
      .network-stat:nth-child(3) { animation-delay: 0.3s; }

      .network-stat {
        transition: all 0.4s ease;
      }

      .network-stat:hover {
        transform: translateY(-10px) scale(1.05);
        box-shadow: 0 20px 40px rgba(0, 140, 140, 0.2);
      }

      .map-placeholder {
        animation: pulse 2s ease-in-out infinite;
      }
    `}</style>

    <section id="network" className="py-24 bg-gradient-to-br from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16 network-header">
          <span className="inline-flex items-center gap-2 bg-slate-100 border border-slate-300 rounded-full px-4 py-2 text-xs font-semibold text-slate-700 mb-6">
            <span className="w-2 h-2 bg-slate-600 rounded-full" />
            Island-Wide Network
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Comprehensive Healthcare Coverage Across Sri Lanka
          </h2>
          <p className="text-gray-600 text-lg leading-relaxed">
            HelaDoc operates a vast network ensuring accessible healthcare services<br />
            to every corner of the island through our distributed channel centers,<br />
            pharmacies, and laboratories.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {[
            { icon: "🏥", stat: "1,000+", label: "Channel Centers", desc: "Healthcare access points" },
            { icon: "💊", stat: "500+", label: "Pharmacies", desc: "Medicine distribution" },
            { icon: "🔬", stat: "500+", label: "Laboratories", desc: "Diagnostic services" }
          ].map((item, idx) => (
            <div key={idx} className="network-stat bg-white rounded-2xl p-8 shadow-lg border border-blue-100 hover:border-teal-300">
              <div className="text-5xl mb-4">{item.icon}</div>
              <div className="text-4xl font-bold text-teal-600 mb-2">{item.stat}</div>
              <div className="text-lg font-semibold text-gray-900 mb-2">{item.label}</div>
              <p className="text-gray-600 text-sm">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Regional Distribution */}
        <div className="bg-gradient-to-r from-teal-600 to-blue-600 rounded-2xl p-12 text-white mb-16">
          <h3 className="text-3xl font-bold mb-4">Regional Distribution</h3>
          <p className="text-lg text-white/90 mb-8">
            On average, each district is served by:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 border border-white/30">
              <div className="text-5xl font-bold text-white mb-2">40+</div>
              <div className="text-lg font-semibold">Channel Centers per District</div>
              <p className="text-white/80 text-sm mt-2">Ensuring local access to healthcare services</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 border border-white/30">
              <div className="text-5xl font-bold text-white mb-2">20+</div>
              <div className="text-lg font-semibold">Pharmacies per District</div>
              <p className="text-white/80 text-sm mt-2">Quick medicine delivery and fulfillment</p>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 border border-white/30">
              <div className="text-5xl font-bold text-white mb-2">15+</div>
              <div className="text-lg font-semibold">Laboratories per District</div>
              <p className="text-white/80 text-sm mt-2">Comprehensive diagnostic services</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
  );
};

export default NetworkInfra;
